import React from 'react';
import CountUp from 'react-countup';

const OurBusiness = () => {

    return (
        <div className="container" data-aos="fade-up">
            <div className="section-title our-business">
                <h3>OUR BUSINESS IN NUMBERS</h3></div>
            <div className="row">
                <div className="col-lg-3 col-md-6">
                    <div className="count-box textbluecolor counter"><span><CountUp start={0} end={1700} duration={4}/>+  </span>
                        <div className='business-sub-heading'>Locations</div>
                        <p>Our Presence </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 ">
                    <div className="count-box textbluecolor counter"><span><CountUp start={0} end={911} duration={4}/>+ </span>
                        <div className='business-sub-heading'>Crores</div>
                        <p>Total Disbursement </p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="count-box textbluecolor counter"><span><CountUp start={0} decimals={2} end={1.56} duration={4}/>+ </span>
                        <div className='business-sub-heading'>Billion</div>
                        <p>Zero-emission Kms.</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 ">
                    <div className="count-box textbluecolor counter"><span><CountUp start={0} end={74} duration={4}/>% </span>
                        <div className='business-sub-heading'>Customers</div>
                        <p>Financially excluded</p>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default OurBusiness



// WEBPACK FOOTER //
// ./src/components/OurBusiness.js